import Router from './routes';
import useAuth from './hooks/useAuth';
import { getOrSetUpAppInsights } from 'appInsights';
import { PropsWithChildren, useEffect } from 'react';
import { registerLicenses } from 'utils/licenses';
import AwaitLoading from 'components/util/AwaitLoading';
import { setLogoutCallback } from 'utils/axios';
import { MsalProvider } from '@azure/msal-react';
import { AuthProvider } from 'contexts/JWTContext';
import { LicenseProvider } from 'contexts/LicenseContext';
import { FeatureFlagsProvider } from 'contexts/FeatureFlagsContext';
import { IPublicClientApplication } from '@azure/msal-browser';
import Intercom from 'pages/intercom/Intercom';
import { useLocation } from 'react-router';
import { SignalRProvider } from 'contexts/SignalRContext';
import { PATH_AUTH } from 'routes/paths';

getOrSetUpAppInsights();
type AdminAppProps = PropsWithChildren<{
  msalInstance: IPublicClientApplication;
}>;

const AdminApp = ({ msalInstance }: AdminAppProps) => (
  <MsalProvider instance={msalInstance}>
    <AuthProvider>
      <LicenseProvider>
        <SignalRProvider>
          <FeatureFlagsProvider>
            <AdminAppCore />
          </FeatureFlagsProvider>
        </SignalRProvider>
      </LicenseProvider>
    </AuthProvider>
  </MsalProvider>
);

export default AdminApp;

const AdminAppCore = () => {
  const { isInitialized, rerenderOnOrgChange, isDataReflectingCurrentOrg, logout } = useAuth();

  useEffect(() => {
    registerLicenses();
  }, []);

  useEffect(() => {
    setLogoutCallback(logout);
  }, [logout]);

  const location = useLocation();
  const isNotFoundPage = location.pathname === '/404';
  const isAuthorizePage = location.pathname === PATH_AUTH.authorize;
  return (
    <>
      {isInitialized && <Router key={rerenderOnOrgChange} />}
      <AwaitLoading
        isLoading={
          !isNotFoundPage && (!isInitialized || (!isDataReflectingCurrentOrg && !isAuthorizePage))
        }
      />
      <Intercom />
    </>
  );
};
